import React from "react";
import { BACKSPACE_ICON } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";

export type PinKeyValue = "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "0" | "backspace";

interface Props {
  value: PinKeyValue;
  onClick: (value: PinKeyValue) => void;
}

const PinKey = (props: Props) => {
  return (
    <div className="PinKey" onClick={() => props.onClick(props.value)}>
      {props.value === "backspace" ? <AppIcon icon={BACKSPACE_ICON} /> : <span>{props.value}</span>}
    </div>
  );
};

export default React.memo(PinKey);
